// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from '../App'
import routes from './route'
import VueRouter from 'vue-router'
import i18n from '../../i18n'
Vue.config.productionTip = false
Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'history',
  routes
})
new Vue({
  el: '#app',
  router,
  render: h => h(App),
  i18n
})



// WEBPACK FOOTER //
// ./src/pages/error/index.js